import { Theme, Components } from '@mui/material/styles';

/* eslint-disable import/prefer-default-export */
export const surfacesCustomizations: Components<Theme> = {
  MuiAccordion: {
    defaultProps: { elevation: 0, disableGutters: true },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 4,
        overflow: 'clip',
        backgroundColor: 'var(--surface)',
        border: '1px solid var(--border)',
        ':before': { backgroundColor: 'transparent' },
        '&:not(:last-of-type)': { borderBottom: 'none' },
        '&:first-of-type': {
          borderTopLeftRadius: 'var(--radius)',
          borderTopRightRadius: 'var(--radius)',
        },
        '&:last-of-type': {
          borderBottomLeftRadius: 'var(--radius)',
          borderBottomRightRadius: 'var(--radius)',
        },
      }),
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: 'none',
        borderRadius: 'var(--radius-sm)',
        '&:hover': { backgroundColor: 'var(--surface-2)' },
        '&:focus-visible': { backgroundColor: 'transparent' },
      }),
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: { mb: 20, border: 'none' },
    },
  },
  MuiPaper: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        backgroundColor: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'none',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 'var(--pad)',
        gap: 16,
        transition: 'all 120ms cubic-bezier(.2,.7,.3,1)',
        backgroundColor: 'var(--surface)',
        borderRadius: 'var(--radius)',
        border: '1px solid var(--border)',
        boxShadow: 'none',
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              border: '1px solid var(--border)',
              boxShadow: 'none',
              backgroundColor: 'var(--surface)',
            },
          },
        ],
      }),
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: { padding: 0, '&:last-child': { paddingBottom: 0 } },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: { padding: 0 },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: { padding: 0 },
    },
  },
};
